import { Box, Skeleton, SxProps, Typography } from '@mui/material'
import ColoredTooltip from 'src/components/Tooltip/ColoredTooltip'

const ErrorThemeChip = ({ theme, loading, sx }: { theme: string; loading?: boolean; sx?: SxProps }) => {
  return (
    <ColoredTooltip title={theme.length > 30 ? theme : null}>
      <Box
        bgcolor="#ECDFFE"
        borderRadius="13px"
        height="26px"
        px={1.5}
        display="flex"
        alignItems="center"
        whiteSpace="nowrap"
        maxWidth="200px"
        sx={sx}>
        {loading ? (
          <Skeleton
            variant="text"
            sx={{ width: '100px', height: '20px' }}
          />
        ) : (
          <Typography
            fontSize={12}
            color="#5600C6"
            fontWeight={600}
            noWrap>
            {theme}
          </Typography>
        )}
      </Box>
    </ColoredTooltip>
  )
}

export default ErrorThemeChip
